"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
//import { IBonusTemplatePlayerTagsListItem } from "../../ctl/BonusTemplatePlayerTagsListCtl";
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var JackpotLocalesList_1 = require("./locales/JackpotLocalesList");
var JackpotLocaleEditor_1 = require("./locales/JackpotLocaleEditor");
var JackpotPlayerTagsList_1 = require("./player_tags/JackpotPlayerTagsList");
var JackpotPlayerTagEditor_1 = require("./player_tags/JackpotPlayerTagEditor");
var JackpotWinHistoryList_1 = require("./win_history/JackpotWinHistoryList");
var JackpotTransferHistoryList_1 = require("./transfer_history/JackpotTransferHistoryList");
var JackpotTransferEditor_1 = require("./transfer_history/JackpotTransferEditor");
var JackpotWinHistoryEditor_1 = require("./win_history/JackpotWinHistoryEditor");
var JackpotOperationsConfig = /** @class */ (function (_super) {
    __extends(JackpotOperationsConfig, _super);
    //private SID_BT: number;
    function JackpotOperationsConfig(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_jackpot_locales = "bonus.jp.locales";
        _this.tab_jackpot_tags = "bonus.jp.tags";
        _this.tab_jackpot_wins = "bonus.jp.wins";
        _this.tab_jackpot_transfers = "bonus.jp.transfers";
        return _this;
    }
    JackpotOperationsConfig.prototype.componentWillMount = function () {
        this.setState({
            jackpotLocalesMode: "LIST",
            jackpotLocalesRecord: null,
            jackpotPlayerTagsMode: "LIST",
            jackpotPlayerTagsRecord: null,
            jackpotTransfersMode: "LIST",
            jackpotWinsMode: "LIST",
            jackpotWinsRecord: null
        });
        this.props.state.setExtBreadCrumbPath(["Настройки джекпота"]);
    };
    JackpotOperationsConfig.prototype.componentWillUnmount = function () {
        //this.props.listAvailAppCurrency.UnSubscribe(this.SID_AC);
    };
    JackpotOperationsConfig.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    JackpotOperationsConfig.prototype.onNewLocaleClick = function () {
        this.setState({ jackpotLocalesMode: "NEW", jackpotLocalesRecord: null });
    };
    JackpotOperationsConfig.prototype.onGoToLocalesListClick = function () {
        this.setState({ jackpotLocalesMode: "LIST", jackpotLocalesRecord: null });
    };
    JackpotOperationsConfig.prototype.onEditLocaleClick = function (record) {
        this.setState({ jackpotLocalesMode: "EDIT", jackpotLocalesRecord: record });
    };
    JackpotOperationsConfig.prototype.getJackpotLocalesObject = function () {
        if (this.state.jackpotLocalesMode === "LIST") {
            return (React.createElement(JackpotLocalesList_1.default, { state: this.props.state, data: this.props.dataJackpotLocales, onGoBack: this.backToRootClick.bind(this), onNewClick: this.onNewLocaleClick.bind(this), rootRecord: this.props.rootRecord, onEditClick: this.onEditLocaleClick.bind(this) }));
        }
        if (this.state.jackpotLocalesMode === "NEW") {
            return (React.createElement(JackpotLocaleEditor_1.default, { data: this.props.dataJackpotLocales, rootRecord: this.props.rootRecord, record: this.state.jackpotLocalesRecord, state: this.props.state, onGoBack: this.onGoToLocalesListClick.bind(this), availLanguages: this.props.availLanguages }));
        }
        if (this.state.jackpotLocalesMode === "EDIT") {
            return (React.createElement(JackpotLocaleEditor_1.default, { data: this.props.dataJackpotLocales, rootRecord: this.props.rootRecord, record: this.state.jackpotLocalesRecord, state: this.props.state, onGoBack: this.onGoToLocalesListClick.bind(this), availLanguages: this.props.availLanguages }));
        }
        throw "No available render for active edit mode -> " + this.state.jackpotLocalesMode;
    };
    JackpotOperationsConfig.prototype.onNewPlayerTagClick = function () {
        this.setState({ jackpotPlayerTagsMode: "NEW", jackpotPlayerTagsRecord: null });
    };
    JackpotOperationsConfig.prototype.onGoToPlayerTagsListClick = function () {
        this.setState({ jackpotPlayerTagsMode: "LIST", jackpotPlayerTagsRecord: null });
    };
    JackpotOperationsConfig.prototype.getJackpotPlayerTagsObject = function () {
        if (this.state.jackpotPlayerTagsMode === "LIST") {
            return (React.createElement(JackpotPlayerTagsList_1.default, { state: this.props.state, data: this.props.dataJackpotRestrictedPlayerTags, onGoBack: this.backToRootClick.bind(this), onNewClick: this.onNewPlayerTagClick.bind(this), rootRecord: this.props.rootRecord }));
        }
        if (this.state.jackpotPlayerTagsMode === "NEW") {
            return (React.createElement(JackpotPlayerTagEditor_1.default, { data: this.props.dataJackpotRestrictedPlayerTags, rootRecord: this.props.rootRecord, state: this.props.state, onGoBack: this.onGoToPlayerTagsListClick.bind(this), availPlayerTags: this.props.availPlayerTags }));
        }
        throw "No available render for active edit mode -> " + this.state.jackpotPlayerTagsMode;
    };
    JackpotOperationsConfig.prototype.onCreateClick = function () {
        this.setState({
            jackpotWinsMode: "NEW"
        });
    };
    JackpotOperationsConfig.prototype.onBackToListClick = function () {
        this.setState({
            jackpotWinsMode: "LIST"
        });
    };
    JackpotOperationsConfig.prototype.getJackpotWinsObject = function () {
        if (this.state.jackpotWinsMode == "LIST") {
            return (React.createElement(JackpotWinHistoryList_1.default, { state: this.props.state, data: this.props.dataJackpotWinHistory, onGoBackClick: this.backToRootClick.bind(this), record: this.props.rootRecord, onCreateClick: this.onCreateClick.bind(this) }));
        }
        if (this.state.jackpotWinsMode == "NEW") {
            return (React.createElement(JackpotWinHistoryEditor_1.default, { state: this.props.state, data: this.props.dataJackpotWinHistory, onGoBack: this.onBackToListClick.bind(this), rootRecord: this.props.rootRecord, dataPlayersAvail: this.props.dataPlayersAvail, dlgSelectPlayer: this.props.dlgSelectPlayer }));
        }
    };
    JackpotOperationsConfig.prototype.onNewTransferClick = function () {
        this.setState({ jackpotPlayerTagsMode: "NEW", jackpotPlayerTagsRecord: null });
    };
    JackpotOperationsConfig.prototype.onGoToTransfersListClick = function () {
        this.setState({ jackpotPlayerTagsMode: "LIST", jackpotPlayerTagsRecord: null });
    };
    JackpotOperationsConfig.prototype.getJackpotTransfersObject = function () {
        if (this.state.jackpotPlayerTagsMode === "LIST") {
            return (React.createElement(JackpotTransferHistoryList_1.default, { state: this.props.state, data: this.props.dataJackpotTransferHistory, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.onNewTransferClick.bind(this), record: this.props.rootRecord }));
        }
        if (this.state.jackpotPlayerTagsMode === "NEW") {
            return (React.createElement(JackpotTransferEditor_1.default, { data: this.props.dataJackpotTransferHistory, record: this.props.rootRecord, state: this.props.state, onGoBack: this.onGoToTransfersListClick.bind(this), availTransferTypes: this.props.availTransferTypes }));
        }
        throw "No available render for active edit mode -> " + this.state.jackpotPlayerTagsMode;
    };
    JackpotOperationsConfig.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_jackpot_locales },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "font" }),
                        "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438"), key: this.tab_jackpot_locales }, this.getJackpotLocalesObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "dice" }),
                        "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439"), key: this.tab_jackpot_wins }, this.getJackpotWinsObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "credit-car" }),
                        "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043F\u0435\u0440\u0432\u043E\u0434\u043E\u0432"), key: this.tab_jackpot_transfers }, this.getJackpotTransfersObject()))));
    };
    return JackpotOperationsConfig;
}(React.Component));
exports.default = JackpotOperationsConfig;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ui/component/JackpotOperationsConfig.tsx
// module id = 2342
// module chunks = 0